(() => {
  const layouts = document.querySelectorAll('[data-enhanced-article]');

  layouts.forEach((layout) => {
    const content = layout.querySelector('[data-article-content]');
    const toc = layout.querySelector('[data-toc]');
    const tocList = layout.querySelector('[data-toc-list]');
    const tocDetails = layout.querySelector('[data-toc-details]');

    if (!content) return;

    const usedIds = new Set(
      Array.from(document.querySelectorAll('[id]'), (element) => element.id).filter(Boolean)
    );
    const headings = Array.from(content.querySelectorAll('h2'));

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const baseId = heading.textContent
          .trim()
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9\u4e00-\u9fff]+/g, '-')
          .replace(/^-+|-+$/g, '') || `section-${index + 1}`;
        let uniqueId = baseId;
        let suffix = 2;

        while (usedIds.has(uniqueId)) {
          uniqueId = `${baseId}-${suffix}`;
          suffix += 1;
        }

        heading.id = uniqueId;
        usedIds.add(uniqueId);
      }

      if (tocList) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        tocList.append(item);
      }
    });

    if (toc && headings.length > 0) {
      toc.hidden = false;

      if (window.matchMedia('(max-width: 989.98px)').matches) {
        if (tocDetails) tocDetails.removeAttribute('open');
        layout.prepend(toc);
      }
    }

    const slots = Array.from(content.querySelectorAll('.blog-product-card-slot'));
    const cards = Array.from(content.querySelectorAll('[data-inline-product-card]'));

    slots.forEach((slot, index) => {
      if (cards[index]) slot.replaceWith(cards[index]);
    });

    const productContainer = content.querySelector('[data-inline-products]');
    if (productContainer && productContainer.children.length === 0) productContainer.remove();
  });
})();
